import { render, staticRenderFns } from "./KnowledgeBaseDetailed.vue?vue&type=template&id=43f2da66&scoped=true&"
import script from "./KnowledgeBaseDetailed.vue?vue&type=script&lang=js&"
export * from "./KnowledgeBaseDetailed.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeBaseDetailed.vue?vue&type=style&index=0&id=43f2da66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f2da66",
  null
  
)

export default component.exports